export const SYSTEM_PARAMS_ACTIONS = {
    GET: 'SYSTEM_PARAMS_GET',
}